<template>
  <div>
    <div class="detailInfo">
      <div class="classImg">
        <img v-if="classInfo.classImage !== null" :src="classInfo.classImage" alt="" />
        <img v-else src="../../assets/images/noimg.png" alt="" />
      </div>

      <div class="nr">
        <div class="c1">{{ classInfo.className }}</div>
        <div class="c2">招生人数：{{ classInfo.classPeopleNumber }}人 &emsp; &emsp;课程总数：{{ classCourseList.length }}</div>
        <div class="c2">授课老师：{{ classInfo.teachers }}</div>

        <div class="bjjs">
          <div class="bjTxt">
            班级介绍：{{ classInfo.classDesc }}

            <div class="zk" @click="detail(classInfo, 1)">详细</div>
          </div>
        </div>

        <div class="bjjs">
          <div class="bjTxt">
            报名须知：{{ classInfo.classDemo }}

            <div class="zk" @click="detail(classInfo, 2)">详细</div>
          </div>
        </div>
      </div>

      <div class="tk" v-if="bmShow && isGx == '01'">
        <div class="wtkBox">
          <img class="tkBac" src="../../assets/images/bgcJu@2x.png" alt="" />
          <div class="wxTtile">温馨提示</div>

          <div class="wx2">{{ bmText }}前往<span style="color: #2d72f3">继续教育专区</span>选课购买。</div>

          <div class="wxBtn" @click="goBm">立即前往报名</div>
        </div>
      </div>

      <div class="kc">
        <div class="k1">课程列表</div>
        <div class="k2" v-if="classInfo.isClassApply == '01'">可选择班级中的部分课程报名</div>
      </div>

      <div class="kcList" v-if="classInfo.isClassApply == '01'">
        <van-checkbox v-model="checkedAll" icon-size="18px" @change="handlAll">
          <span style="font-size: 14px; color: #333; padding-top: 4px">全选</span>
        </van-checkbox>

        <van-checkbox-group v-model="result" ref="checkboxGroup" icon-size="18px" @change="handlChaper">
          <van-checkbox :name="item" v-for="item in classCourseList" :key="item.id" :disabled="item.isBuy == '02'" label-disabled>
            <div class="kcBox" @click="courseDetail(item)">
              <div class="kec">
                <div class="cplauter">
                  <img v-if="item.cimage !== null" :src="item.cimage" alt="" />
                  <img v-else src="../../assets/images/noimg.png" alt="" />
                </div>
                <div class="cpTxt">
                  <div class="t1">{{ item.cname }}</div>
                  <div class="t2">学时：{{ item.ccredithour }}学时 是否考试：{{ classInfo.isClassExam ? '是' : '否' }}</div>
                  <div class="t3"><span>¥</span>{{ item.totalMoney.toFixed(1) }}</div>
                </div>
                <div class="skBox">
                  <div style="display: flex; align-items: center">
                    <div>
                      <img style="width: 16px; height: 16px; margin-top: 2px" src="../../assets/images/sk.png" alt="" />
                    </div>
                    <div>试看</div>
                  </div>
                </div>
              </div>
            </div>
          </van-checkbox>
        </van-checkbox-group>
      </div>
      <div class="kcList" v-if="classInfo.isClassApply == '02'" style="padding-top: 10px !important">
        <div class="kcBox" v-for="item in classCourseList" :key="item.id" @click="courseDetail(item)">
          <div class="kec">
            <div class="cplauter">
              <img v-if="item.cimage !== null" :src="item.cimage" alt="" />
              <img v-else src="../../assets/images/noimg.png" alt="" />
            </div>
            <div class="cpTxt">
              <div class="t1">{{ item.cname }}</div>
              <div class="t2">学时：{{ item.ccredithour }}学时 是否考试：{{ classInfo.isClassExam ? '是' : '否' }}</div>
              <div class="t3"><span>¥</span>{{ item.totalMoney.toFixed(1) }}</div>
            </div>
            <div class="skBox">
              <div style="display: flex; align-items: center">
                <div>
                  <img style="width: 16px; height: 16px; margin-top: 2px" src="../../assets/images/sk.png" alt="" />
                </div>
                <div>试看</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hejBox" v-if="classInfo.classEnrolStatus !== '01'">
      <div class="titol" v-if="classInfo.isClassApply == '01'"><span style="font-size: 14px">合计：¥</span>{{ totolNum.toFixed(1) }}</div>
      <div class="titol" v-if="classInfo.isClassApply == '02'">
        <span style="font-size: 14px">合计：¥</span>{{ classInfo.classPrice.toFixed(1) }}
      </div>
      <div class="gmBtn" @click="payOrder">立即购买</div>
    </div>
    <van-popup v-model="balanceShow" round>
      <div class="balanBox">
        <div class="b1">账户余额抵扣支付</div>

        <van-checkbox-group v-model="balanRadio" icon-size="16px" class="bn2" @change="onCheckboxChange">
          <van-cell-group class="bn2">
            <van-cell clickable @click="toggleCheck('1')" v-if="balance > 0">
              <div>
                <div class="b2">
                  账户余额支付 ¥{{ classInfo.isClassApply == '01' ? totolNum.toFixed(2) : Number(classInfo.classPrice).toFixed(2) }}
                </div>
                <div class="b3">剩余{{ balanZkNum.toFixed(2) < 0 ? 0 : balanZkNum.toFixed(2) }}元</div>
              </div>
              <template #right-icon>
                <van-checkbox name="1" ref="checkboxes" />
              </template>
            </van-cell>
            <van-cell clickable @click="toggleCheck('2')" v-if="surplusIntegral > 0">
              <div>
                <div class="b2">账户积分支付 ¥{{ Math.min(surplusIntegral / 30, classInfo.classPrice).toFixed(2) }}</div>
                <div class="b3" v-if="this.balanRadio[0] == '2'">
                  剩余积分抵扣金额{{ balanZkNum1.toFixed(2) < 0 ? 0 : balanZkNum1.toFixed(2) }}元
                </div>
                <div class="b3" v-else>剩余积分抵扣金额{{ (surplusIntegral / 30).toFixed(2) }}元</div>
              </div>
              <template #right-icon>
                <van-checkbox name="2" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>

        <div class="btnBox">
          <div class="btn" style="background: #e4e4e4; color: #666666" @click="balanceShow = false">取消</div>
          <div class="btn" @click="toOrder">立即购买</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { getClassInfo, toGenerateOrder } from '@/api/classDetail';
import { toAllReadyBuy } from '@/api/myClass';
import { Dialog } from 'vant';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      bmShow: false,
      bmText: '',
      checkedAll: false, //全选
      result: [],
      classInfo: {}, //班级数据
      classCourseList: [], //课程数据
      totolNum: 0, //总价
      psel: false,
      courseIds: [],
      balance: 0, //账户余额抵扣
      balanceShow: false,
      balanRadio: [],
      surplusIntegral: 0, //积分
      balanZkNum: 0, //折扣后剩下的余额
      balanZkNum1: 0, //折扣后剩下的积分
      payFalg: false,
      jsShow: false,
      totalCredithour: 0, //选中学时
      classCredithour: '',
      jsText: '',
      isGx: '02'
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    toggleCheck(name) {
      if (this.balanRadio[0] === name) {
        this.balanRadio = [];
      } else {
        this.balanRadio = [name];
      }
      this.onCheckboxChange(this.balanRadio);
    },
    onCheckboxChange(value) {
      console.log('当前选中:', value);
    },
    toAllReadyBuy() {
      toAllReadyBuy().then(res => {
        if (res.data.data.msg == '') {
          this.bmShow = false;
        } else {
          this.bmShow = true;
        }
        this.bmText = res.data.data.msg;
      });
    },
    goBm() {
      this.$router.push({
        path: '/chooseClass',
        query: {
          type: '0702'
        }
      });
    },
    //查看介绍详细
    detail(msg, type) {
      this.jsShow = true;
      if (type == 1) {
        Dialog.confirm({
          title: '班级介绍',
          message: msg.classDesc == null ? '暂无介绍！' : msg.classDesc,
          confirmButtonColor: '#2A70F2'
        })
          .then(() => {})
          .catch(() => {
            // this.$utils.showToast('用户点击了取消');
          });
      } else {
        Dialog.confirm({
          title: '报名须知',
          message: msg.classDemo == null ? '暂无须知！' : msg.classDemo,
          confirmButtonColor: '#2A70F2'
        })
          .then(() => {})
          .catch(() => {
            // this.$utils.showToast('用户点击了取消');
          });
      }
    },
    //点击课程详情
    courseDetail(item) {
      this.$router.push({
        path: '/courseDetail',
        query: {
          id: item.courseId,
          classEnrolStatus: this.classInfo.classEnrolStatus
        }
      });
    },
    //判断是否抵扣
    payOrder() {
      if (this.courseIds.length == 0 && this.classInfo.isClassApply !== '02') {
        this.$utils.showToast('请先勾选需要购买的课程！');
        return false;
      }
      // 检查 classCourseList 中是否包含 isBuy 为 '02' 的项目
      const hasIsBuy02 = this.classCourseList.some(item => item.isBuy === '02');
      if (!hasIsBuy02) {
        if (this.totalCredithour < this.classCredithour && this.classInfo.isClassApply !== '02') {
          this.$utils
            .showConfirm({
              title: '温馨提示',
              message: '勾选的课程学时小于该班级要求的学时，请继续添加课程！'
            })
            .then(() => {});
          return false;
        }
      }
      //金额为0元
      console.log(this.totolNum);
      if (this.totolNum == 0) {
        this.toOrder(1);
        return false;
      }
      //账户余额不为0
      // if (this.balance !== 0 || this.surplusIntegral != 0) {
      //   this.balanceShow = true;
      //   this.balanZkNum = this.balance - this.totolNum;

      //   this.balanZkNum1 = (this.surplusIntegral / 30).toFixed(2) - this.totolNum;
      //   console.log(this.surplusIntegral, '6789');
      // } else {
        this.toOrder();
      // }
    },
    //购买生成订单
    toOrder(type) {
      if (this.payFalg) {
        this.$utils.showToast('点击过快，请稍后再试！');
        return false;
      }

      let arr = [];
      this.courseIds.forEach(v => {
        arr.push(v.courseId);
      });
      let data = {};
      if (type == 1) {
        //为1的时候就是金额为0元。走余额支付逻辑
        this.balanRadio[0] = 1;
      }
      if (this.classInfo.isClassApply !== '02') {
        //非整体报名
        data = {
          classId: this.classInfo.id,
          // classIds: this.classInfo.id,
          // orderId: this.$route.query.orderId ? this.$route.query.orderId : '',
          courseIds: arr.toString(),
          // derateType: this.balanRadio[0] == '1' ? '01' : this.balanRadio[0] == '2' ? '02' : '03' //判断是否勾选了抵扣
        };
      } else {
        //整体报名
        data = {
          classId: this.classInfo.id,
          // courseIds: arr.toString(),
          // orderId: this.$route.query.orderId ? this.$route.query.orderId : '',
          // derateType: this.balanRadio[0] == '1' ? '01' : this.balanRadio[0] == '2' ? '02' : '03' //判断是否勾选了抵扣
        };
      }
      this.payFalg = true;
      setTimeout(() => {
        this.payFalg = false;
      }, 5000);
      toGenerateOrder(data).then(res => {
        this.payFalg = false;
        if (res.data.data.result == 0) {
          //创建订单失败返回信息
          this.$utils.showToast(res.data.data.msg);
          return false;
        }
        if (res.data.data.result == 4) {
          //创建订单失败返回信息
          this.$utils.showConfirm(res.data.data.msg);
          return false;
        }
        if (res.data.data.result == 1) {
          //余额小于金额，抵扣后跳转到收银台继续支付或没勾选账户抵扣跳收银台
          let data = res.data.data.order;
          this.$router.push({
            path: '/payType',
            query: data
          });
        }
        //余额大于金额，直接购买成功
        if (res.data.data.result == 2) {
          let data = res.data.data.order;
          this.$router.push({
            path: '/paySuccess',
            query: data
          });
        }
        //已有订单
        if (res.data.data.result == 3) {
          this.balanceShow = false;
          Dialog.confirm({
            title: '温馨提示',
            message: res.data.data.msg,
            confirmButtonColor: '#2A70F2'
          })
            .then(() => {
              if (this.$route.query.orderId == '' || this.$route.query.orderId == null) {
                this.$router.push('/myOrder');
              } else {
              }
            })
            .catch(() => {
              // this.$utils.showToast('用户点击了取消');
            });
          return false;
        }
      });
    },
    //全选
    handlAll(e) {
      if (e) {
        this.psel = false;
        this.$refs.checkboxGroup.toggleAll({
          checked: true,
          skipDisabled: true
        });
      } else {
        if (this.psel) {
          return false;
        }
        this.psel = false;
        // 全部反选，并跳过禁用的复选框
        this.$refs.checkboxGroup.toggleAll({
          skipDisabled: true
        });
      }
    },
    //选中课程
    handlChaper(e) {
      this.courseIds = e;
      this.totolNum = 0;
      this.totalCredithour = 0;
      console.log(e, '88');
      e.forEach(v => {
        this.totolNum += v.totalMoney;
        this.totalCredithour += v.ccredithour;
      });
      //提出禁用的复选框
      const xzArr = this.classCourseList.filter(item => item.isBuy == '01');
      if (e.length == xzArr.length) {
        this.checkedAll = true;
      } else {
        this.psel = true;
        this.checkedAll = false;
      }
    },
    getList() {
      getClassInfo({ classId: this.$route.query.classId, token: localStorage.getItem('token') }).then(res => {
        this.isGx = res.data.data.isGx;
        this.classInfo = res.data.data.tClass;
        this.classCredithour = res.data.data.tClass.classCredithour;
        this.classCourseList = res.data.data.classCourseList;
        this.balance = res.data.data.balance;
        if (res.data.data.surplusIntegral) {
          this.surplusIntegral = res.data.data.surplusIntegral;
          console.log(this.surplusIntegral, '3333');
        } else {
          this.balanceShow = false;
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
    this.toAllReadyBuy();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.tk {
  margin-top: 10px;
  padding: 0 15px;
  .wtkBox {
    width: 100%;
    height: 151px;
    position: relative;
    padding: 21px 22px 18px 25px;
    .tkBac {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 151px;
      z-index: -1;
    }
    .closeBox {
      width: 24px;
      height: 24px;
      position: absolute;
      bottom: -30px;
      left: 50%;
      transform: translate(-50%);
      cursor: pointer;
    }

    .wxTtile {
      font-size: 13px;
      color: #333333;
    }
    .wx2 {
      margin-top: 12px;
      font-size: 14px;
      color: #333;
    }
    .wxBtn {
      margin-top: 13px;
      width: 120px;
      height: 40px;
      background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
      box-shadow: 0px 3px 4px 0px rgba(21, 85, 202, 0.31);
      border-radius: 20px 20px 20px 20px;
      text-align: center;
      font-size: 12px;
      line-height: 40px;
      color: #fff;
      cursor: pointer;
    }
  }
}
.detailInfo {
  margin-top: 46px;
  padding-bottom: 103px;
  .classImg {
    width: 100%;
    height: 300px;
    background: #eee;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .nr {
    width: 100%;
    padding: 15px 20px;
    background: #fff;
    .c1 {
      width: 100%;
      color: #333333;
      font-size: 18px;
      margin-bottom: 4px;
    }
    .c2 {
      margin-top: 6px;
      color: #333;
      font-size: 13px;
    }

    .bjjs {
      width: 100%;
      height: 60px;
      color: #666666;
      font-size: 13px;
      background: #f6f8fa;
      margin-top: 12px;
      padding: 12px 15px;
      .bjTxt {
        width: 100%;
        position: relative;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 限制显示行数 */
      }
      /* 第二行遮挡效果 */
      .zk {
        position: absolute;
        right: 0;
        bottom: 0px;
        background: #f6f8fa;
        color: #2a70f2;
        font-size: 13px;
        text-align: right;
      }
    }
  }
  .kc {
    padding: 0 15px;
    margin-top: 33px;
    margin-bottom: 11px;
    display: flex;
    align-items: center;
    .k1 {
      color: #333333;
      font-size: 17px;
    }
    .k2 {
      color: #999999;
      font-size: 12px;
      margin-left: 5px;
    }
  }
  .kcList {
    width: 100%;
    padding: 20px 15px 30px 15px;
    background: #fff;
    .kcBox {
      margin-top: 24px;
      .kec {
        display: flex;
        margin-left: 7px;
        position: relative;
        .skBox {
          position: absolute;
          width: 74px;
          height: 32px;
          background: #f3f3f5;
          border-radius: 27px 27px 27px 27px;
          bottom: 0;
          right: 0;
          display: flex;
          align-items: center;
          color: #2a70f2;
          font-size: 13px;
          justify-content: center;
        }
        .cplauter {
          width: 110px;
          height: 88px;
          background: #d9d9d9;
          border-radius: 8px 8px 8px 8px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 8px 8px 8px 8px;
          }
        }
        .cpTxt {
          margin-left: 10px;
          .t1 {
            width: 170px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-top: 5px;
            color: #000000;
            font-size: 16px;
          }
          .t2 {
            margin-top: 8px;
            color: #666666;
            font-size: 13px;
          }
          .t3 {
            margin-top: 11px;
            span {
              font-size: 12px;
            }
            font-size: 17px;
            color: #ff2d31;
          }
        }
      }
    }
  }
}

.hejBox {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 15px;
  background: #ffffff;
  justify-content: space-between;
  .titol {
    color: #ff2d31;
    font-size: 22px;
  }
  .gmBtn {
    width: 110px;
    height: 40px;
    background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
    border-radius: 8px 8px 8px 8px;
    text-align: center;
    line-height: 40px;
    color: #ffffff;
    font-size: 14px;
  }
}

.balanBox {
  width: 300px;
  height: auto;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 22px 20px;
  .b1 {
    color: #333333;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
  }
  .bn2 {
    margin-top: 20px;
    width: 100% !important;
    background: #f6f8fa !important;
    border-radius: 8px 8px 8px 8px;
    .b2 {
      color: #333333;
      font-size: 14px;
    }
    .b3 {
      color: #999999;
      font-size: 12px;
    }
  }

  .btnBox {
    display: flex;
    justify-content: space-between;
    .btn {
      margin-top: 20px;
      width: 117px;
      height: 48px;
      background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
      border-radius: 8px 8px 8px 8px;
      text-align: center;
      line-height: 48px;
      font-size: 15px;
      color: #fff;
    }
  }
}
</style>
